import jQuery from 'jquery';
import { move } from './move';
import { swipe } from './swipe';
import { unslider } from './unslider';

function oxygenVSBInitTabs(element) {
  if (element!==undefined) {
    jQuery(element).find('.oxy-tabs-wrapper').addBack('.oxy-tabs-wrapper').each(function(index) {
      jQuery(this).children('.oxy-tabs-wrapper > div').eq(0).trigger('click');
    });
  }
  else {
    jQuery('.oxy-tabs-wrapper').each(function(index) {
      jQuery(this).children('.oxy-tabs-wrapper > div').eq(0).trigger('click');
    });
  }
};

const startOxygen = () => {
  // Enable Oxygen's move, swipe, and unslider UI tricks for the Hourly Planner
  move();
  swipe();
  unslider();

  // Initialize the Oxygen tabs
  jQuery(document).ready(function() {
    oxygenVSBInitTabs();
  });

  jQuery(document).ready(function($) {
    $('#slider-196-139.ct_unique_slider_4419 .oxygen-unslider-container:not(.unslider-horizontal,.unslider-fade)').unslider({
      autoplay: false,
      delay: 3000,
      animation: 'horizontal',
      speed: 750,
      arrows: true,
      nav: false,
      infinite: false
    })
  });
  
  // handle clicks on tabs  
  jQuery("body").on('click', '.oxy-tabs-wrapper > div', function(e) {
  
      /* a tab or an element that is a child of a tab has been clicked. prevent any default behavior */
      //e.preventDefault();
      
      /* which tab has been clicked? (e.target might be a child of the tab.) */

      const clicked_tab = jQuery(e.target).closest('.oxy-tabs-wrapper > div');
      const index = clicked_tab.index();  
      
      /* which tabs-wrapper is this tab inside? */
      const tabs_wrapper = jQuery(e.target).closest('.oxy-tabs-wrapper');
  
      /* what class dp we use to signify an active tob? */
      const class_for_active_tab = tabs_wrapper.attr('data-oxy-tabs-active-tab-class');
      
      /* make all the other tabs in this tabs-wrapper inactive */
      jQuery(tabs_wrapper).children('.oxy-tabs-wrapper > div').removeClass(class_for_active_tab);
  
      /* make the clicked tab the active tab */    
      jQuery(tabs_wrapper).children('.oxy-tabs-wrapper > div').eq(index).addClass(class_for_active_tab);
  
      /* which tabs-contents-wrapper is used by these tabs? */
      const tabs_contents_wrapper_id = tabs_wrapper.attr('data-oxy-tabs-contents-wrapper');
  
      /* hide all of the content */
      const select = '#' + tabs_contents_wrapper_id + " > div";
      jQuery(select).addClass('oxy-tabs-contents-content-hidden');
      
      /* unhide the content corresponding to the active tab*/
      jQuery(select).eq(index).removeClass('oxy-tabs-contents-content-hidden');
    
  });   
}; 

export { startOxygen };